import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}, l = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  d: "M14.667 4.833h-4a.504.504 0 0 1-.5-.5c0-.273.226-.5.5-.5h4c.273 0 .5.227.5.5 0 .274-.227.5-.5.5M4 4.833H1.333a.504.504 0 0 1-.5-.5c0-.273.227-.5.5-.5H4c.273 0 .5.227.5.5 0 .274-.227.5-.5.5"
}, null, -1), n = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  d: "M6.667 7.167a2.84 2.84 0 0 1-2.834-2.834A2.84 2.84 0 0 1 6.667 1.5 2.84 2.84 0 0 1 9.5 4.333a2.84 2.84 0 0 1-2.833 2.834m0-4.667a1.832 1.832 0 1 0 0 3.667 1.832 1.832 0 1 0 0-3.667m8 9.667H12a.504.504 0 0 1-.5-.5c0-.274.227-.5.5-.5h2.667c.273 0 .5.226.5.5 0 .273-.227.5-.5.5m-9.334 0h-4a.504.504 0 0 1-.5-.5c0-.274.227-.5.5-.5h4c.274 0 .5.226.5.5 0 .273-.226.5-.5.5"
}, null, -1), r = /* @__PURE__ */ t("path", {
  fill: "currentColor",
  d: "M9.333 14.5A2.84 2.84 0 0 1 6.5 11.667a2.84 2.84 0 0 1 2.833-2.834 2.84 2.84 0 0 1 2.834 2.834A2.84 2.84 0 0 1 9.333 14.5m0-4.667a1.832 1.832 0 1 0 0 3.667 1.832 1.832 0 1 0 0-3.667"
}, null, -1), a = [
  l,
  n,
  r
];
function h(s, i) {
  return e(), o("svg", c, [...a]);
}
const _ = { render: h };
export {
  _ as default,
  h as render
};
